var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKebabMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 11.6666C10.9211 11.6666 11.6673 10.9205 11.6673 9.99998C11.6673 9.07951 10.9211 8.33331 10.0007 8.33331C9.08018 8.33331 8.33398 9.07951 8.33398 9.99998C8.33398 10.9205 9.08018 11.6666 10.0007 11.6666Z",
    fill: "#202A3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 5.83333C10.9211 5.83333 11.6673 5.08714 11.6673 4.16667C11.6673 3.24619 10.9211 2.5 10.0007 2.5C9.08018 2.5 8.33398 3.24619 8.33398 4.16667C8.33398 5.08714 9.08018 5.83333 10.0007 5.83333Z",
    fill: "#202A3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 17.5C10.9211 17.5 11.6673 16.7538 11.6673 15.8334C11.6673 14.9129 10.9211 14.1667 10.0007 14.1667C9.08018 14.1667 8.33398 14.9129 8.33398 15.8334C8.33398 16.7538 9.08018 17.5 10.0007 17.5Z",
    fill: "#202A3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebabMenu);
export default __webpack_public_path__ + "static/media/kebabMenu.c9810f04.svg";
export { ForwardRef as ReactComponent };